// extracted by mini-css-extract-plugin
export default {"container":"coocies_consent_container__NDba+","text":"coocies_consent_text__PrA7T","link":"coocies_consent_link__G+izo coocies_consent_text__PrA7T"};